<template>
  <section class="TaC">
    <div v-if="!paymentOption">
      <header class="title-header">
        <span class="back-btn" @click="goBack()">
          <img src="@/assets/images/ic_back.svg" alt />
        </span>
      </header>
      <div class="content">
        <h2>benefits</h2>
        <ul>
          <li>1. Lorem ipsum dolor sit amet</li>
          <li>2. Lorem ipsum dolor sit amet</li>
          <li>3. Lorem ipsum dolor sit amet</li>
          <li>4. Lorem ipsum dolor sit amet</li>
        </ul>
      </div>

      <div class="content-2">
        <h2>Terms & Conditions</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci aut
          quibusdam enim quo sint expedita commodi recusandae illum nulla fuga
          corporis sit error maxime deserunt, architecto, animi iste fugiat
          consequatur?
        </p>
        <ul>
          <li>1. recusandae illum nulla fuga corporis sit</li>
          <li>2. recusandae illum nulla fuga corporis sit</li>
          <li>3. recusandae illum nulla fuga corporis sit</li>
          <li>4. recusandae illum nulla fuga corporis sit</li>
          <li>5. recusandae illum nulla fuga corporis sit</li>
          <li>6. recusandae illum nulla fuga corporis sit</li>
        </ul>
      </div>
      <span class="bottom_btn" @click="goToPay()">Register Now</span>
    </div>
    <payment-option
      v-if="paymentOption"
      :isPaymentOption="paymentOption"
      @closePayment="closePaymentFunc"
      :getformData="formData"
    />
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import CustomToaster from "../components/Common/CustomToaster";
import PaymentOption from "./PaymentOption";

export default {
  name: "TermsCondition",
  components: {
    PaymentOption,
  },
  props: {
    formData: {
      type: Object,
    },
    isTermsCondition: {
      type: Boolean,
    },
  },
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      paymentOption: false,
    };
  },
  methods: {
    closePaymentFunc(value) {
       if(value)
        this.paymentOption = false
    },
    goToPay() {
      // this.$router.push('/payment-option')
      this.paymentOption = !this.paymentOption;
    },
    goBack() {
      console.log(this.isTermsCondition);
      this.$emit("closeTerms", this.isTermsCondition);
    },
  },
  mounted() {
    console.log(this.formData, this.isTermsCondition);
  },
};
</script>
